import { Api } from '../api';
import { recipients } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  RecipientCreateRequest,
  RecipientGetListRequest,
  RecipientGetMandatoryFieldsRequest,
  RecipientGetRecentRequest,
  RecipientResponse,
  RecipientUpdateRequest,
} from './models';

export class RecipientsApi extends Api {
  static getById = async (request: string, signal?: AbortSignal) => {
    const result = await this.get<ApiResponse<RecipientResponse>>({ url: recipients.getById(), queryParams: { id: request }, signal });
    return result.data;
  };

  static getList = (request: RecipientGetListRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<RecipientResponse[]>>({ url: recipients.getList(), queryParams: request, signal });

  static getRecent = (request: RecipientGetRecentRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<RecipientResponse[]>>({ url: recipients.getRecent(), queryParams: request, signal });

  static getMandatoryFields = (request: RecipientGetMandatoryFieldsRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<string[]>>({ url: recipients.getMandatoryFields(), queryParams: request, signal });

  static create = (request: RecipientCreateRequest, signal?: AbortSignal) =>
    this.post<RecipientCreateRequest, ApiResponse<RecipientResponse>>({ url: recipients.create(), data: request, signal });

  static update = (request: RecipientUpdateRequest, signal?: AbortSignal) =>
    this.put<RecipientUpdateRequest, RecipientResponse>({ url: recipients.update(), data: request, signal });

  static deleteRecipient = (id: string) =>
    this.delete<{ Id: string }, ApiResponse<RecipientResponse>>({ url: recipients.delete(id), queryParams: { Id: id }, data: { Id: id } });
}
